import { PromiseExtended, Table } from 'dexie';
import { DoctorProfile, MyAccessibleDoctor, MyProfileResponse } from './types/doctorProfile';
import { Visit } from './types/visit';
import { DexieDbType } from './types/dexie';
import { notification } from 'antd';

class DummyBridge {
    navigate(
        type: 'push' | 'replace',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        params,
    ): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return;
    }
    getDoc(): DoctorProfile | undefined {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return;
    }
    async getLocalVisitByIds(ids: string[]): Promise<Visit[]> {
        return [];
    }

    async getData(tableName: string): Promise<Partial<Table> | undefined> {
        return;
    }

    track(name: string, params?: { [k: string]: string | undefined }): void {
        console.log('MXP DUMMY EVENT', { name, params });
    }
    async isHmisEnabled(): Promise<boolean> {
        return false;
    }

    getIdb(): DexieDbType {
        return (undefined as unknown) as DexieDbType;
    }

    getMe(): MyProfileResponse {
        return {
            docs: [
                {
                    id: '161368382403778',
                    personal: {
                        name: {
                            f: 'vikalp sahni',
                            l: '',
                        },
                        pic:
                            'https://jugaad.s3.amazonaws.com/0cade0e6-d194-4b57-a4e8-3f5fd61694e7.png',
                    },
                    professional: {
                        username: 'vikalpsahni',
                        clinics: [{ _id: '63dcd048a27092601cf8c5ec' }],
                    },
                },
                {
                    id: '161373341988952',
                    personal: {
                        name: {
                            f: 'Bhaskar Chaudhary',
                            l: '',
                        },
                        pic:
                            'https://doctoronboarding.s3.amazonaws.com/aa1d4ff5-fae1-4725-b1b4-31e46188cfb9.png',
                    },
                    professional: {
                        username: 'bhaskar',
                        clinics: [{ _id: '63dcd048a27092601cf8c5ec' }],
                    },
                },
                {
                    id: '161419272566611',
                    personal: {
                        name: {
                            f: 'Anusheel Singh',
                            l: '',
                        },
                        pic: 'https://a.eka.care/doctor-avatar/161419272566611?v=1659701997',
                    },
                    professional: {
                        username: 'anusheel',
                        clinics: [{ _id: '63dcd048a27092601cf8c5ec' }],
                    },
                },
                {
                    id: '161467756044203',
                    personal: {
                        name: {
                            f: 'Raghunandan Kapoor',
                            l: '',
                        },
                        pic:
                            'https://doctoronboarding.s3.amazonaws.com/1fc013a1-73af-46a2-98bc-b039d4fd1636.jpg',
                    },
                    professional: {
                        username: 'raghunandan',
                        clinics: [{ _id: '63dcd048a27092601cf8c5ec' }],
                    },
                },
                {
                    id: '167805359211002',
                    personal: {
                        name: {
                            f: 'Vishwa Vignesh',
                            l: '',
                        },
                        pic: 'https://cdn.eka.care/vagus/cl2rhhut3000l0sg1fkcghr9j.png',
                    },
                    professional: {
                        username: 'dr-vishwa-vignesh-bengaluru',
                        clinics: [{ _id: '63dcd048a27092601cf8c5ec' }],
                    },
                },
                {
                    id: '168872855236766',
                    personal: {
                        name: {
                            f: 'Eka HMIS God',
                            l: '',
                        },
                        pic: 'https://cdn.eka.care/vagus/cl2rhhut3000l0sg1fkcghr9j.png',
                    },
                    professional: {
                        username: 'dr-eka-hmis-god-spine-surgeon-bengaluru',
                        clinics: [{ _id: '63dcd048a27092601cf8c5ec' }],
                    },
                },
            ],
            clinics: [
                {
                    id: '63dcd048a27092601cf8c5ec',
                    name: 'Default Clinic',
                    abdm: {
                        hfr_id: 'IN2910000565',
                    },
                },
                {
                    id: '6238e18bbe73c0686cc787f1',
                    name: 'CLinic Number @5',
                    abdm: {
                        hfr_id: 'IN0510000242',
                    },
                },
                {
                    id: '63dcd063a27092601cf8c5ed',
                    name: 'Another Clinic',
                    abdm: {
                        hfr_id: 'IN2910000537',
                    },
                },
                {
                    id: '65df2044e4e6dc001d4e6fa2',
                    name: 'Test clinic',
                    abdm: {
                        hfr_id: 'IN0510000242',
                    },
                },
                {
                    id: '65e03fad6934bd001d94108a',
                    name: 'New HFR Clinic',
                    abdm: {
                        hfr_id: 'IN0510000242',
                    },
                },
                {
                    id: '65ec283c2d4fe9001d8fd39c',
                    name: 'Arrakis Clinic',
                    abdm: {
                        hfr_id: '',
                    },
                },
            ],
            business: {
                id: '10000',
            },
            loginmeta: {
                role: 'DOCTOR',
                docid: '161419272566611',
                switch: false,
                userid: '161419272566611',
                username: 'Anusheel Singh',
                isvalid: true,
            },
        };
    }

    amIDoctorOnly(): boolean {
        return true;
    }
    canAccessRoute(match: string): boolean {
        return true;
    }

    isAllowed(action: string): boolean {
        return true;
    }

    isAccessAvailable(name: string): boolean {
        return true;
    }

    showAccessDeniedError(): void {
        notification.error({
            message: 'Access Denied',
            description: 'You do not have access to perform this action',
            duration: 5,
        });
    }
}

export default DummyBridge;
